import { LucideIcon } from 'lucide-react'

interface ToolPageHeroProps {
  icon: LucideIcon
  badgeText: string
  title: string
  description: string
  children?: React.ReactNode
}

export function ToolPageHero({
  icon: Icon,
  badgeText,
  title,
  description,
  children,
}: ToolPageHeroProps) {
  return (
    <section className="pt-12 pb-8 px-4">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
            <Icon className="w-4 h-4" />
            {badgeText}
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{title}</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">{description}</p>
        </div>
        {children}
      </div>
    </section>
  )
}
